import { onCookiesConsentReady, CookiesConsent } from "@story/story_cookies_consent";

let cookiesConsentDialogInstance = null;

class CookiesConsentDialog {

	constructor(templateUrl) {
		this.templateUrl = templateUrl;
		this.dialog = null;
	}

	async show() {
		this.close();

		const response = await fetch(this.templateUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } });
		const content = await response.text();

		let dialog = document.createElement("div");
		dialog.classList.add("page-cookies-consent");
		dialog.innerHTML = content;

		this.dialog = dialog.firstChild;

		document.body.append(this.dialog);
	}

	close() {
		if (this.dialog) {
			this.dialog.remove();
			this.dialog = null;
		}
	}
}

document.addEventSelectorListener("click", ".cookies-consent-link", function(event, target) {
	event.preventDefault();

	if (!cookiesConsentDialogInstance) {
		cookiesConsentDialogInstance = new CookiesConsentDialog(target.getAttribute("href"));
		cookiesConsentDialogInstance.show();
	}
});

CookiesConsent.onClose = function(instance) {
	if (cookiesConsentDialogInstance) {
		cookiesConsentDialogInstance.close();
		cookiesConsentDialogInstance = null;
	}
}

onCookiesConsentReady(function(allowed, changes) {
	if (allowed.includes("all")) {
		// window.dataLayer.push(["consent", "update", { ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted", analytics_storage: "granted" }]);
		gtag('consent', 'update', {
			'ad_storage': 'granted',
			'ad_user_data': 'granted',
			'ad_personalization': 'granted',
			'analytics_storage': 'granted'
		});
	}
	else {
		// window.dataLayer.push(["consent", "update", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "denied" }]);
		gtag('consent', 'update', {
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'analytics_storage': 'denied'
		});
	}
});